import React, { useEffect } from "react";
import { HiX } from "react-icons/hi";
import "./Modal.css";

function Modal({
  zIndex,
  isOpen,
  onClose,
  importModalStyles,
  children,
  closeButton,
  miniStore,
}) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  return (
    <div
      className={isOpen ? (zIndex ? "modal2" : "modal1") : "d-none"}
      onClick={() => (onClose ? onClose() : "")}
    >
      <div
        className={`${
          importModalStyles
            ? "modal_content_import"
            : miniStore
            ? "modal_content_mini_store custom-scroll"
            : "modal_content custom-scroll"
        }`}
        onClick={(event) => event.stopPropagation()}
      >
        {onClose && closeButton && (
          <button
            className="modal-close-button"
            onClick={onClose}
            title="Close"
          >
            <HiX size={22} />
          </button>
        )}
        {isOpen && children}
      </div>
    </div>
  );
}

export default Modal;
